import { FC } from 'react';
import c from 'classnames';
import { Icon, IconName } from '../Icon';
import { Typography } from '../Typography/Typography';
import styles from './StatusPill.module.css';
import type { StatusColor } from '@repo/types';

export interface StatusPillProps {
  status: string;
  color: StatusColor;
  /** Takes the dot's place, for statuses the design marks with a glyph. */
  iconName?: IconName;
  onClick?: () => void;
}

export const StatusPill: FC<StatusPillProps> = ({
  status,
  color,
  iconName,
  onClick,
}) => {
  return (
    <div
      className={c(
        styles.statusPill,
        styles[color],
        onClick && styles.clickable,
      )}
      onClick={onClick}
    >
      {iconName ? (
        <Icon name={iconName} size='s' />
      ) : (
        <div className={c(styles.dot, styles[color])} />
      )}
      <Typography variant='label'>{status}</Typography>
    </div>
  );
};
